export default "__VITE_ASSET__BcEV9D8m__"